import {DependencyList, EffectCallback, useEffect, useRef} from 'react';

export function useUpdate(effect: EffectCallback, deps?: DependencyList, hook = useEffect) {
    const mountingRef = useRef(true);
    hook(() => {
        if (mountingRef.current) {
            mountingRef.current = false;
        } else {
            return effect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
